import { render, staticRenderFns } from "./AddTags.vue?vue&type=template&id=2002343f"
import script from "./AddTags.vue?vue&type=script&lang=js"
export * from "./AddTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports